"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferType = exports.BlockchainFunction = void 0;
var BlockchainFunction;
(function (BlockchainFunction) {
    BlockchainFunction["CreateEvent"] = "EVENT.CREATE";
    BlockchainFunction["GetEvent"] = "EVENT.GET";
    BlockchainFunction["GetTicketConfig"] = "EVENT.GET_TICKET_CONFIG";
    BlockchainFunction["CreateTicketConfig"] = "EVENT.ADD_TICKET_CONFIG";
    BlockchainFunction["IssueTicket"] = "TICKET.ISSUE";
    BlockchainFunction["GetTicket"] = "TICKET.GET";
    BlockchainFunction["TransferTicket"] = "TICKET.TRANSFER";
    BlockchainFunction["InvalidateTicket"] = "TICKET.INVALIDATE";
    BlockchainFunction["ActivateTicket"] = "TICKET.ACTIVATE";
    BlockchainFunction["ApproveKyc"] = "TICKET.APPROVE_KYC";
    BlockchainFunction["MarkForSale"] = "TICKET.MARK_FOR_SALE";
})(BlockchainFunction || (exports.BlockchainFunction = BlockchainFunction = {}));
var OfferType;
(function (OfferType) {
    OfferType["Direct"] = "DIRECT";
    OfferType["Market"] = "MARKET";
    OfferType["Auction"] = "AUCTION";
})(OfferType || (exports.OfferType = OfferType = {}));
//# sourceMappingURL=types.js.map